import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../openapi';

@Pipe({
  name: 'applicationRoadOccupationPurposeLabel',
  standalone: true
})
export class ApplicationRoadOccupationPurposeLabelPipe implements PipeTransform {

  private allowedUrls: string[] = [
    '/odszkodowanie-za-straty',
    '/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi',
    '/zajecie-pasa-prowadzenie-robot',
    '/uzgodnienie-projektu-zjazdu',
    '/lokalizacja-przebudowa-zjazdu',
    '/zezwolenie-przejazdy-pojazdow-nienormatywnych',
    '/awaryjne-zajecie-pasa-drogowego',
    '/opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych',
    '/zajecie-pasa-umieszczenie-obiektow-budowlanych',
    '/umieszczenie-reklamy',
    '/zgloszenie-uwagi-ogolne-oznakowanie-drog'
  ];

  transform(value: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case this.allowedUrls.includes(value?.service?.url || ''): {
        return 'Cel złożenia wniosku';
      }
      default: {
        return 'Cel zajęcia';
      }
    }
  }

}
